// https://sponda-kohteet.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/html/code/show/BuCwkCmXTSGVh6JMCl6zPg

import React from 'react';
import PropTypes from 'prop-types';

import { colorClassNames } from 'lib/settings';

const mapMarker = require(`!raw-loader!../../../../assets/${'marker'}.svg`);

const Map = props => {
	const {
		options,
		building: {
			mapUrl,
		},
	} = props;

	const backgroundColor = options['background-color'];
	const bgColorClass = backgroundColor in colorClassNames ? colorClassNames[backgroundColor] : '';

	let componentClass = 'b-component b-map';

	if (bgColorClass) {
		componentClass += ' b-slot-theme-' + bgColorClass;
	}

	const style = {
		backgroundColor,
	};

	const mapStyle = {
		backgroundImage: `url(${mapUrl})`
	};

	return (
		<div className={componentClass} style={style}>
			<div className="map" style={mapStyle} dangerouslySetInnerHTML={{__html: mapMarker }} />
		</div>
	);
}

Map.propTypes = {
	options: PropTypes.object,
	slotActive: PropTypes.bool,
	building: PropTypes.object,
	buildingFieldLocalNames: PropTypes.object,
}

export default Map;
